import React from 'react';
// import PropTypes from 'prop-types';
// import { Button, buttonTypes} from "../../../components/Button";

import './SuccessRegister.scss';

const SuccessSendEmailRecetPass = () => {

  // const checkEmail = () => {
  //   window.open(`https://${props.email.split('@')[1]}`, '_blank');
  //   props.hideAll();
  // };

  return(
    <div className="success-modal">
      <div className="success-modal__body ion-android-happy">
        <p className="success-modal__title">
          Check your email!!!
        </p>
        <p className="success-modal__description">
          A message is on the way to continue the password reset process.
        </p>
      </div>

      {/* <div className="success-modal__buttons">
        <Button
          type={buttonTypes.AUTHENTICATION}
          className="button-main"
          name="Check my Mail"
          onClick={()=>checkEmail()}
        />
      </div> */}
    </div>
  )
};

SuccessSendEmailRecetPass.propTypes = {
  // email: PropTypes.string,
  // hideAll: PropTypes.func,
};

export default SuccessSendEmailRecetPass;


// WEBPACK FOOTER //
// ./src/app/containers/Auth/components/succsesSendEmailResetPass.js